import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=209b0667&"
import script from "./Document.vue?vue&type=script&lang=ts&"
export * from "./Document.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports